export class UserGroup {
  public id = '';
  public name = '';
}
